import React, { useContext } from 'react';
import { CartContext } from 'constants/contexts';
import {
  Divider,
  Paper,
} from '@mui/material';
import Header from './Header';
import Items from './Items';
import Action from './Action';

function Cart() {
  const { items } = useContext(CartContext);

  function renderContent() {
    if (items.length === 0) {
      return null;
    }
    return (
      <>
        <Header />
        <Divider sx={{ my: 3 }} />
        <Items />
        <Action />
      </>
    );
  }
  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 4,
        borderRadius: 0,
        height: '100%',
      }}
    >
      {renderContent()}
    </Paper>
  );
}

Cart.Header = Header;
Cart.Items = Items;
Cart.Action = Action;

export default Cart;
